import React, {useState, useRef} from 'react';
import {BrandLogo} from 'shared-components/Logos';
import { LanguageBox } from "shared-components/Toggles";
import { useLocation } from 'react-router-dom';
import MenuList from '@material-ui/core/MenuList';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'styles/header.scss'

const HeaderBar = ({showMenu}) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  if (location.pathname === "/tracking-historic") {
    return ''
  }

  return (
    <div className="headerBar">
      <div>{
        showMenu ? 'MENU' : 
        <div style={{width: '64px'}}></div>
      }</div>
      <BrandLogo />
      <Button 
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        aria-label="Menu"
        onClick={handleToggle}>
        <FontAwesomeIcon icon="ellipsis-v" />
      </Button>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow">
                  <LanguageBox isMenuItem={true} />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
export default HeaderBar